module.exports = __webpack_public_path__ + "img/gaugeBlack.d87608ac.svg";